<template>
    <div v-if="isOpen" class="modal fade show" style="display: block; background: #1c1d1c33">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header py-1 px-2">
                    <h1 class="rj-title mb-0">Reject {{ versionLabel }}</h1>
                    <button type="button" class="btn-close" aria-label="Close" @click="emit('close')"></button>
                </div>
                <div class="modal-body px-2">
                    <label class="rj-label">Reason <span class="rj-required">*</span></label>
                    <textarea
                        v-model="note"
                        class="form-control"
                        rows="4"
                        maxlength="1000"
                        placeholder="Write why this version is rejected"
                    ></textarea>
                </div>
                <div class="modal-footer py-1 px-2">
                    <button type="button" class="btn btn-outline-secondary" @click="emit('close')">Cancel</button>
                    <button type="button" class="btn btn-danger" :disabled="busy || ! note.trim()" @click="emit('submit', note.trim())">
                        <span v-if="busy" class="spinner-border spinner-border-sm me-50"></span>
                        <span>Reject</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, watch } from 'vue'

const props = defineProps({
    isOpen: {
        type: Boolean,
        default: false
    },
    versionLabel: {
        type: String,
        default: ''
    },
    busy: {
        type: Boolean,
        default: false
    }
})

const emit = defineEmits(['close', 'submit'])

const note = ref('')

watch(() => props.isOpen, () => {
    note.value = ''
})
</script>

<style scoped>
.rj-title {
    font-size: 18px;
    font-weight: 700;
    color: #101828;
}
.rj-label {
    display: block;
    margin-bottom: 4px;
    font-size: 13px;
    font-weight: 600;
    color: #344054;
}
.rj-required {
    color: #d92d20;
}
</style>
